import { Observable, of } from 'rxjs';
import { Crop } from '../../Models/Geometry/Crop/Crop';
import { PxCrop } from '../../Models/Geometry/Crop/PxCrop';
import { Size } from '../../Models/Geometry/Size';
import { ImageWorker } from '../ImageWorker/ImageWorker';
import { ImageCropper } from './ImageCropper';

export class SmoImageCropper extends ImageWorker implements ImageCropper {
  public getImageFromVideo(video: HTMLVideoElement): Observable<HTMLImageElement> {
    const size = { width: video.videoWidth, height: video.videoHeight };
    const pxCrop = new PxCrop(0, 0, size.width, size.height);
    return this.createImageFromDataUrl(this.cropElement(video, pxCrop).toDataURL(), size);
  }

  public cropImage(image: HTMLImageElement, crop: Crop): Observable<HTMLImageElement> {
    const size = this.getImageSize(image);
    const pxCrop: Crop = crop.toPx(size);
    const croppedCanvas: HTMLCanvasElement = this.cropElement(image, pxCrop);
    return this.createImageFromDataUrl(croppedCanvas.toDataURL(), { width: pxCrop.width, height: pxCrop.height });
  }

  public rotateImage(image: HTMLImageElement, rotation: number): Observable<HTMLImageElement> {
    if (rotation === 0) {
      return of(image);
    }
    const size = this.getImageSize(image);
    const rotatedCanvas: HTMLCanvasElement = this.rotateElement(image, size, rotation);
    return this.createImageFromDataUrl(rotatedCanvas.toDataURL(), size);
  }

  private cropElement(element: HTMLVideoElement | HTMLImageElement, { x, y, width, height }: Crop): HTMLCanvasElement {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Unable to get 2d context');
    }
    ctx.drawImage(element, x, y, width, height, 0, 0, width, height);

    return canvas;
  }

  private rotateElement(element: HTMLImageElement | HTMLVideoElement, size: Size, rotation: number): HTMLCanvasElement {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Unable to get 2d context');
    }
    ctx.rotate(rotation);
    ctx.drawImage(element, 0, 0, size.width, size.height);

    return canvas;
  }
}
